import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminService from "./adminService";

export const addListingData = createAsyncThunk(
  "admin/addListing",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No refresh token provided");
      }
      const response = await adminService.addListingData(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const deleteListingData = createAsyncThunk(
  "admin/deleteListing",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No refresh token provided");
      }
      const response = await adminService.deleteListingData(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const getUnlistedInventory = createAsyncThunk(
  "admin/getUnlistedInventory",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No refresh token provided");
      }
      const response = await adminService.getUnlistedInventory(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const getStockReconciliation = createAsyncThunk(
  "admin/getStockReconciliation",
  async (_, thunkAPI: any) => {
    try {
      const response = await adminService.getStockReconciliation();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const addUnlistedInventory = createAsyncThunk(
  "admin/addUnlistedInventory",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No refresh token provided");
      }
      const response = await adminService.addUnlistedInventory(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const assignUnlistedInventory = createAsyncThunk(
  "admin/assignUnlistedInventory",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No refresh token provided");
      }
      const response = await adminService.assignUnlistedInventory(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const updateUnlistedOrderStatus = createAsyncThunk(
  "admin/updateUnlistedOrderStatus",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No refresh token provided");
      }
      const response = await adminService.updateUnlistedOrderStatus(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const updateUnlistedInventory = createAsyncThunk(
  "admin/updateUnlistedInventory",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No refresh token provided");
      }
      const response = await adminService.updateUnlistedInventory(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const updateUnlistedInvestor = createAsyncThunk(
  "admin/updateUnlistedInvestor",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No refresh token provided");
      }
      const response = await adminService.updateUnlistedInvestor(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const softDeleteUnlistedInvestor = createAsyncThunk(
  "admin/softDeleteUnlistedInvestor",
  async (data: { investorId: number }, thunkAPI: any) => {
    try {
      if (!data?.investorId) {
        throw new Error("Investor ID is required");
      }
      const response = await adminService.softDeleteUnlistedInvestor(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const unlistedInvestorPanVerify = createAsyncThunk(
  "admin/unlistedInvestorPanVerify",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No refresh token provided");
      }
      const response = await adminService.unlistedInvestorPanVerify(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const unlistedInvestorBankVerify = createAsyncThunk(
  "admin/unlistedInvestorBankVerify",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No refresh token provided");
      }
      const response = await adminService.unlistedInvestorBankVerify(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const uploadUnlistedInventory = createAsyncThunk(
  "admin/uploadUnlistedInventory",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No refresh token provided");
      }
      const response = await adminService.uploadUnlistedInventory(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const addBrockerageLogFromFile = createAsyncThunk(
  "admin/addBrockerageLogFromFile",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) {
        throw new Error("No data provided");
      }
      const response = await adminService.addBrockerageLogFromFile(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const uploadUnlistedReconciliation = createAsyncThunk(
  "admin/uploadUnlistedReconciliation",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) throw new Error("No data provided");
      const response = await adminService.uploadUnlistedReconciliation(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const getUnlistedReconciliationHistory = createAsyncThunk(
  "admin/getUnlistedReconciliationHistory",
  async (_: void, thunkAPI: any) => {
    try {
      const response = await adminService.getUnlistedReconciliationHistory();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const updateUnlistedReconciliation = createAsyncThunk(
  "admin/updateUnlistedReconciliation",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) throw new Error("No data provided");
      const response = await adminService.updateUnlistedReconciliation(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const deleteUnlistedReconciliation = createAsyncThunk(
  "admin/deleteUnlistedReconciliation",
  async (data: any, thunkAPI: any) => {
    try {
      if (!data) throw new Error("No data provided");
      const response = await adminService.deleteUnlistedReconciliation(data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  data: [],
  response: {},
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
};
export const mfSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    resetState: (state) => initialState,
  },

  extraReducers: (builder) => {
    builder
      .addCase(addListingData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addListingData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(addListingData.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(deleteListingData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteListingData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(deleteListingData.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(getUnlistedInventory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnlistedInventory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload.data || [];
      })
      .addCase(getUnlistedInventory.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(getStockReconciliation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStockReconciliation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload.data || [];
      })
      .addCase(getStockReconciliation.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(addUnlistedInventory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addUnlistedInventory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(addUnlistedInventory.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(assignUnlistedInventory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(assignUnlistedInventory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(assignUnlistedInventory.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(updateUnlistedOrderStatus.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateUnlistedOrderStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.response = action.payload;
      })
      .addCase(updateUnlistedOrderStatus.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(updateUnlistedInventory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateUnlistedInventory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.response = action.payload;
      })
      .addCase(updateUnlistedInventory.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(updateUnlistedInvestor.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateUnlistedInvestor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.response = action.payload;
      })
      .addCase(updateUnlistedInvestor.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(softDeleteUnlistedInvestor.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(softDeleteUnlistedInvestor.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.response = action.payload;
      })
      .addCase(softDeleteUnlistedInvestor.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(unlistedInvestorPanVerify.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(unlistedInvestorPanVerify.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.response = action.payload;
      })
      .addCase(unlistedInvestorPanVerify.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(unlistedInvestorBankVerify.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(unlistedInvestorBankVerify.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.response = action.payload;
      })
      .addCase(unlistedInvestorBankVerify.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(uploadUnlistedInventory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(uploadUnlistedInventory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.response = action.payload;
      })
      .addCase(uploadUnlistedInventory.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(uploadUnlistedReconciliation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(uploadUnlistedReconciliation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.response = action.payload;
      })
      .addCase(uploadUnlistedReconciliation.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(getUnlistedReconciliationHistory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUnlistedReconciliationHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.response = action.payload;
      })
      .addCase(getUnlistedReconciliationHistory.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(updateUnlistedReconciliation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateUnlistedReconciliation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.response = action.payload;
      })
      .addCase(updateUnlistedReconciliation.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      })
      .addCase(deleteUnlistedReconciliation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteUnlistedReconciliation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.response = action.payload;
      })
      .addCase(deleteUnlistedReconciliation.rejected, (state, action) => {
        state.isError = true;
        state.isLoading = false;
        state.isSuccess = false;
        state.message = action.error.message || "";
      });
  },
});

export const { resetState } = mfSlice.actions;
export default mfSlice.reducer;
